import {
  BuildingIcon,
  TestTubeIcon,
  PackageIcon,
  MatrixLogoIcon,
  HouseIcon,
  NewspaperIcon,
  QrCodeIcon,
  CodeBlockIcon,
  MapPinAreaIcon,
  GearIcon,
  HashIcon,
  UploadIcon,
  UsersThreeIcon,
  UserGearIcon,
  PencilSimpleIcon,
  ListChecksIcon,
  ListBulletsIcon
} from 'prove-common'

export const adminNavigation = [
  {
    label: 'Oversikt',
    items: [
      {
        to: '/home',
        label: 'Oversikt',
        icon: HouseIcon,
        description: 'Snarveier til administrasjon.'
      }
    ]
  },
  {
    label: 'Administrasjon',
    items: [
      {
        to: '/products',
        label: 'Produkter',
        icon: PackageIcon,
        description: 'Produktnavn og koder som brukes ved prøvetaking.'
      },
      {
        to: '/matrices',
        label: 'Matriser',
        icon: MatrixLogoIcon,
        description: 'Materialet som prøvene tas fra.'
      },
      {
        to: '/substances',
        label: 'Substanser',
        icon: TestTubeIcon,
        description: 'Analyserte stoffer, koder og visningsnavn.'
      },
      {
        to: '/ok-programs',
        label: 'OK-program',
        icon: HashIcon,
        description: 'Overvåkings- og kartleggingsprogrammer.'
      },
      {
        to: '/purposes',
        label: 'Hensikter',
        icon: ListChecksIcon,
        description: 'Hensikten med prøvetakingen.'
      },
      {
        to: '/sub-purposes',
        label: 'Underhensikter',
        icon: ListBulletsIcon,
        description: 'Mer spesifikke hensikter med prøvetakingen.'
      },
      {
        to: '/sampling-sites',
        label: 'Uttakssteder',
        icon: MapPinAreaIcon,
        description: 'Typer uttakssteder med norske og engelske navn.'
      },
      {
        to: '/labs',
        label: 'Laboratorier',
        icon: BuildingIcon,
        description: 'Laboratorieinformasjon og mottaksadresser.'
      },
      {
        to: '/schemas',
        label: 'Registreringsskjemaer',
        icon: CodeBlockIcon,
        description: 'Maler for tilleggsinformasjon ved registrering.'
      },
      {
        to: '/teams',
        label: 'Team',
        icon: UsersThreeIcon,
        description: 'Team tilknyttet avdelinger og seksjoner.'
      },
      {
        to: '/user-permissions',
        label: 'Brukertilganger',
        icon: UserGearIcon,
        description: 'Administrer brukertilganger.'
      },
      {
        to: '/edit-sample',
        label: 'Rediger prøve',
        icon: PencilSimpleIcon,
        description: 'Søk opp en prøve og endre tildelt inspektør.'
      },
      {
        to: '/news',
        label: 'Nyheter',
        icon: NewspaperIcon,
        description: 'Meldinger som vises i Prøve-applikasjonene.'
      }
    ]
  },
  {
    label: 'Utviklerverktøy',
    items: [
      {
        to: '/code-generator',
        label: 'Kodegenerator',
        icon: QrCodeIcon,
        description: 'Generer koder til testing av slaktelapper.'
      },
      {
        to: '/results-upload',
        label: 'Resultatopplasting',
        icon: UploadIcon,
        description: 'Send analyseresultater og last opp PDF-vedlegg.'
      }
    ]
  },
  {
    label: 'Innstillinger',
    items: [
      {
        to: '/settings',
        label: 'Innstillinger',
        icon: GearIcon,
        description: 'Innlogget bruker og utlogging.'
      }
    ]
  }
]
